/**
 * RAAZZ PDP add-to-cart — AJAX + cart drawer / redirect per block setting.
 */
(() => {
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function getCartSectionId() {
    const drawer = document.querySelector('hdt-cart-drawer[section-id]');
    return drawer ? drawer.getAttribute('section-id') : null;
  }

  function getActionAfterAtc(form) {
    const hidden = form.querySelector('[name="action_added"]');
    if (hidden && hidden.value) return hidden.value;

    const wrap = form.closest('[data-raazz-atc-action]');
    if (wrap && wrap.dataset.raazzAtcAction) return wrap.dataset.raazzAtcAction;

    return window.themeHDN?.settings?.actionAfterATC || 'open_cart_drawer';
  }

  function isRaazzPdpForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    return !!form.closest('.raazz-pdp-buy-button, .hdt-sticky-btn-atc');
  }

  function setSubmitting(form, isLoading) {
    form.querySelectorAll('[type="submit"]').forEach((btn) => {
      btn.disabled = isLoading;
      btn.toggleAttribute('aria-busy', isLoading);
    });
  }

  function notifyCart(cart, actionAfterATC) {
    document.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          actionAfterATC,
          cart,
        },
      })
    );
  }

  function redirectAfterAtc(actionAfterATC) {
    if (!actionAfterATC || actionAfterATC.indexOf('go_') === -1) return;
    window.location.href = `${ROOT}${actionAfterATC === 'go_cart_page' ? 'cart' : 'checkout'}`;
  }

  async function handleSubmit(event) {
    const form = event.target;
    if (!isRaazzPdpForm(form)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const idInput = form.querySelector('[name="id"]');
    if (idInput) idInput.disabled = false;

    const actionAfterATC = getActionAfterAtc(form);
    const sectionId = getCartSectionId();
    const formData = new FormData(form);

    if (sectionId) formData.set('sections', sectionId);

    setSubmitting(form, true);
    document.dispatchEvent(new CustomEvent('theme:loading:doing', { bubbles: true }));

    try {
      const addResponse = await fetch(`${ROOT}cart/add.js`, {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      const addJson = await addResponse.json();
      document.dispatchEvent(new CustomEvent('theme:loading:done', { bubbles: true }));

      if (!addResponse.ok) {
        form.dispatchEvent(
          new CustomEvent('cart:add:error', {
            bubbles: true,
            detail: {
              isGiftCardRecipient: form.dataset.giftCardRecipient === 'true',
              error: addJson.description || addJson.message || 'Could not add to cart',
            },
          })
        );
        return;
      }

      const cartResponse = await fetch(`${ROOT}cart.js`, {
        headers: { Accept: 'application/json' },
      });
      const cart = await cartResponse.json();
      cart.sections = addJson.sections;

      notifyCart(cart, actionAfterATC);

      form.dispatchEvent(
        new CustomEvent('variant:add', {
          bubbles: true,
          detail: {
            items: Object.prototype.hasOwnProperty.call(addJson, 'items') ? addJson.items : [addJson],
            actionAfterATC,
            cart,
          },
        })
      );

      if (actionAfterATC.indexOf('go_') > -1) {
        redirectAfterAtc(actionAfterATC);
      }
    } catch (error) {
      document.dispatchEvent(new CustomEvent('theme:loading:done', { bubbles: true }));
      console.error(error);
    } finally {
      setSubmitting(form, false);
    }
  }

  document.addEventListener('submit', handleSubmit, true);
})();
